/**
 * Collect all toggle widgets with faq structure
 * and output all the question and ansers in one JSON LD structure
 * at the end of last toggle widget
 */
'use strict';

( function ( $, w ) {

    var $window = $( w );

    $window.on( 'elementor/frontend/init', function() {

        const faqs = document.querySelectorAll('.elementor-widget-toggle [type="application/ld+json"]');
        // only if more than one toggle widget on page
        if( faqs.length > 1 ) {
            let qaSet;
            faqs.forEach((faq, i) => {

                // first widget toggle will be added to
                if(i == 0) {
                    qaSet = JSON.parse(faq.textContent);
                }
                // add questions and answers of other toggle widgets to first one
                else {
                    let curentQaSet = JSON.parse(faq.textContent);
                    if(curentQaSet.mainEntity !== undefined && qaSet.mainEntity !== undefined) {
                        qaSet.mainEntity = qaSet.mainEntity.concat(curentQaSet.mainEntity);
                    }
                }
                // Add new json lt script to last toggle widget
                if(i == faqs.length - 1) {
                    let script = document.createElement('script');
                    script.setAttribute('type', 'application/ld+json');
                    let json = document.createTextNode(JSON.stringify(qaSet));
                    script.appendChild(json);
                    faq.parentNode.appendChild(script);
                }
                // remove script from widget
                faq.remove();
            });
        }
    } );

} ( jQuery, window ) );